import React from "react";
import '../Common.scss';
import './Overview.scss';
import defaultImage from '../../../assets/default.png';
import {Image} from '../../../components/CustomImage';
export default class OverView extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const firstSectionImge = [];
        let roomFloorPlanImageUrl='';
        if(pageDetails)
            roomFloorPlanImageUrl = pageDetails?.roomFloorPlanImageUrl;
        firstSectionImge.push({imageUrl: pageDetails?.planImageUrl});
        const images = pageDetails?.perspectiveImages || [];
        images?.length && firstSectionImge.push(images[0]);
        const secondSectionImages = images.filter((image, i) => (i > 0 && i < 4));

        firstSectionImge.forEach(i => {
            i.elevationName = i?.imageName?.split('-')?.[2]?.split('[')?.[0]?.toLowerCase() || '';
            !i.elevationName?.includes('wall') && (i.elevationName = "3D View");
        });
        secondSectionImages.forEach(i => {
            i.elevationName = i?.imageName?.split('-')?.[2]?.split('[')?.[0]?.toLowerCase() || '';
            !i.elevationName?.includes('wall') && (i.elevationName = "3D View");
        });

        return (
            <React.Fragment>
                <div className="page-over-container">
                    <div className="image-section-1">
                        {
                            firstSectionImge.map((image, index) => {
                                return (
                                    <div key={index}>
                                        <p className="image-container-heading">{index === 0 ? "Plan" : (image?.elevationName || "3D View")}</p>
                                        { index === 0?
                                        <div className="floorplan">
                                        <div className="planimage">
                                        <Image crossOrigin="anonymous" src={image?.imageUrl ? `${image?.imageUrl}?ver=${new Date().getTime()}` : defaultImage} alt="" className={`page-image ${index === 0?'plan-image':''}`} />
                                        </div>
                                        <div className="floorimage">
                                        {
                                         <Image crossOrigin="anonymous"  src={roomFloorPlanImageUrl} alt="" className={`page-image ${index === 0?'floor-image':''}`} /> 
                                        }
                                        </div>
                                        </div>
                                        :
                                            <div className="planimage2">
                                                 <Image crossOrigin="anonymous" src={image?.imageUrl ? `${image?.imageUrl}?ver=${new Date().getTime()}` : defaultImage} alt="" className={`page-image ${index === 0?'plan-image':''}`} />
                                            </div>
                                        }
                                    
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="image-section-2">
                        {
                            secondSectionImages.map((image, index) => {
                                return (
                                    <div key={index}>
                                        <p className="image-container-heading">{image?.elevationName || "3D View"}</p>
                                        <Image crossOrigin="anonymous" className="page-image" src={image?.imageUrl ? `${image?.imageUrl}?ver=${new Date().getTime()}` :defaultImage  } alt="" />
                                    </div>
                               )
                            })
                        }
                    </div>
                </div>
            </React.Fragment>

        )
    }

}